import gql from 'graphql-tag';

export const GET_TEAMS_QEURY = gql`
  query($userID: String!) {
    teams(userID: $userID) {
      team_id
      display_name
      user_role
      team_role {
        roleIdentifier {
          name,
          team
        },
        permissions {
          action
          resource
          allowed
        }
      }
    }
  }
`;

export default {
  GET_TEAMS_QEURY,
};
